// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home-title-module--wrapper--o2xkn","title":"home-title-module--title--1MP8N","baseline":"home-title-module--baseline--2RCPE"};